import {Decoder, field, number, object, string} from 'json-bouncer'
import {Cis2UserRole, cis2UserRoleDecoder} from './Cis2UserRole'

export interface Cis2User {
    readonly id: number
    readonly email: string
    readonly firstName: string
    readonly lastName: string
    readonly role: Cis2UserRole
}

export function cis2UserDecoder(): Decoder<Cis2User> {
    return object({
        id: field('id', number()),
        email: field('email', string()),
        firstName: field('firstName', string()),
        lastName: field('lastName', string()),
        role: field('role', cis2UserRoleDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Cis2User.ts